import { render, staticRenderFns } from "./Form12.vue?vue&type=template&id=2ec5897c&scoped=true"
import script from "./Form12.vue?vue&type=script&lang=ts"
export * from "./Form12.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=2ec5897c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5897c",
  null
  
)

export default component.exports